export default __webpack_public_path__ + "static/media/token_33T.95d002eb.svg";